/**
 *  Redux saga class init
 */
import { takeLatest, all } from 'redux-saga/effects';
import * as types from '../actions/types';
import * as loginSaga from './loginSaga';
import logoutSaga from './logoutSaga';
import * as signupSaga from './signupSaga';
import * as caseSaga from './caseSaga';
import * as accountSaga from './accountSaga';

function* rootSaga() {
  yield all([takeLatest(types.LOGIN_REQUEST, loginSaga.login)]);
  yield all([takeLatest(types.RESET_PASSWORD_REQUEST, loginSaga.resetPasswordSaga)]);
  yield all([takeLatest(types.RESET_PASSWORD_CONFIRM_REQUEST, loginSaga.resetPasswordConfirmSaga)]);
  yield all([takeLatest(types.LOG_OUT, logoutSaga)]);
  yield all([takeLatest(types.SIGNUP_REQUEST, signupSaga.signupSaga)]);
  yield all([takeLatest(types.CONFIRM_SIGNUP_REQUEST, signupSaga.confirmSignUpSaga)]);
  yield all([takeLatest(types.RESEND_CODE_REQUEST, signupSaga.resendCodeSignUpSaga)]);
  yield all([takeLatest(types.CREATE_CASE_REQUEST, caseSaga.createCaseSaga)]);
  yield all([takeLatest(types.GET_ALL_MY_CASES, caseSaga.getAllMyCasesSaga)]);
  yield all([takeLatest(types.UPDATE_CASE_BASICINFO_REQUEST, caseSaga.updateCaseBasicInfoSaga)]);
  yield all([
    takeLatest(types.UPDATE_CASE_CONTACTINFO_REQUEST, caseSaga.updateCaseContactInfoSaga)
  ]);
  yield all([takeLatest(types.UPDATE_CASE_MDINFO_REQUEST, caseSaga.updateCaseMDInfoSaga)]);
  yield all([takeLatest(types.UPDATE_CASE_BCHINFO_REQUEST, caseSaga.updateCaseBCHInfoSaga)]);
  // yield all([takeLatest(types.GET_CASE_BY_ID_REQUEST, caseSaga.getCaseByIdSaga)]);
  yield all([takeLatest(types.CLEAR_CASE_THEN_NAVIGATE_REQUEST, caseSaga.clearCaseSaga)]);
  //yield all([
  //  takeLatest(types.CREATE_ACCOUNT_REQUEST, accountSaga.createAccountSaga),
  //]);
  yield all([takeLatest(types.UPDATE_FIRSTNAME_REQUEST, accountSaga.updateAccountFirstNameSaga)]);
  yield all([takeLatest(types.UPDATE_LASTNAME_REQUEST, accountSaga.updateAccountLastNameSaga)]);
  yield all([takeLatest(types.UPDATE_EMAIL_REQUEST, accountSaga.updateAccountEmailSaga)]);
  yield all([takeLatest(types.UPDATE_PHONE_REQUEST, accountSaga.updateAccountPhoneSaga)]);
  yield all([takeLatest(types.UPDATE_PASSWORD_REQUEST, accountSaga.updatePasswordSaga)]);
  yield all([takeLatest(types.GET_PHONE_REQUEST, accountSaga.getPhoneSaga)]);

  yield all([takeLatest(types.ACCESS_CASE_REQUEST, caseSaga.AccessCaseSaga)]);
}
export default rootSaga;
